import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { RelatorioDisparo } from '../model/relatorio-disparo/relatorio-disparo.model';

@Injectable({ providedIn: 'root' })
export class RelatorioDisparoService {

  private readonly http = inject(HttpClient);
  private readonly urlBase = environment.urlBase.concat('/relatorio-disparo');

  buscarRelatorioPorDisparoId(disparoId: number): Observable<RelatorioDisparo> {
    return this.http.get<RelatorioDisparo>(`${this.urlBase}/disparoId/${disparoId}`);
  }
}
